<template>
  <div>
    <validation-observer ref="simpleRules">
      <b-form-group
        label="Tambah Kurir"
        label-for="v-kurir"
      >
        <v-select
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="name"
          :options="courierList"
          @input="onAddNewCourier"
        />
      </b-form-group>

      <div class="business-card my-4">
        <app-collapse
          v-if="selectedCouriers.length"
          type="margin"
          accordion
        >
          <app-collapse-item
            v-for="(item, index) in selectedCouriers"
            :key="`list-courier-${index}`"
          >
            <template #header>
              <div class="d-flex justify-content-between align-items-center w-100">
                <span class="lead collapse-title">{{ item.name }}</span>
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-danger"
                  class="btn-icon rounded-circle"
                  @click.stop="onDeleteCourier(index, item)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </div>
            </template>
            <b-card-body>
              <div
                v-for="(service, serviceIndex) in item.services"
                :key="`service-${item.id}-${serviceIndex}`"
                class="d-flex justify-content-between align-items-center mb-1"
              >
                <div>
                  {{ service.name }} <span v-if="service.category">({{ service.category.toUpperCase() }})</span>
                </div>
                <div>
                  <b-form-checkbox
                    v-model="service.is_selected"
                    switch
                    inline
                    :disabled="isSyncing"
                    @change="onServiceToggle"
                  />
                </div>
              </div>
              <div
                v-if="isLoadingServices"
                class="text-center py-1"
              >
                <b-spinner variant="primary" />
              </div>
              <div v-else-if="!item.services || item.services.length === 0">
                Tidak ada layanan tersedia.
              </div>
            </b-card-body>
          </app-collapse-item>
        </app-collapse>

        <empty-data
          v-else
          title="Data Kurir Kosong"
          description="Belum ada kurir yang ditambahkan"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BFormGroup,
  BCardBody,
  BFormCheckbox,
  BSpinner,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

export default {
  components: {
    BFormGroup,
    vSelect,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
    BCardBody,
    BFormCheckbox,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isProfile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: '',
      isSyncing: false,
      isLoadingServices: false,
    }
  },
  computed: {
    ...mapState('courier', ['couriers']),
    ...mapState('brand', ['selectedCouriers']),
    courierList() {
      return this.couriers.filter(el => !el.is_hidden && this.selectedCouriers.findIndex(ex => ex.courier_id === el.id) === -1)
    },
    brandId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
  },
  created() {
    this.getCourierList()
    if (this.brandId) {
      this.fetchBrandCouriers()
    }
  },
  methods: {
    ...mapActions('courier', ['getCourierList', 'pushCourier', 'getBrandCouriers']),
    ...mapActions('brand', [
      'pushCourier',
      'deleteCourier',
      'pushCourierMe',
      'deleteCourierMe',
      'syncCourierServices',
    ]),
    onDeleteCourier(index, item) {
      if (this.isProfile) {
        this.deleteCourierMe({ index, data: item })
      } else {
        this.deleteCourier({ index, data: item, brandId: this.brandId })
      }
    },
    async onAddNewCourier(data) {
      if (this.isProfile) {
        await this.pushCourierMe({ data })
      } else {
        await this.pushCourier({ data, brandId: this.brandId })
      }
      this.selected = ''
      // Re-fetch the list to get complete data with services
      this.fetchBrandCouriers()
    },
    async fetchBrandCouriers() {
      this.isLoadingServices = true
      try {
        await this.getBrandCouriers(this.brandId)
      } finally {
        this.isLoadingServices = false
      }
    },
    async onServiceToggle() {
      this.isSyncing = true
      try {
        const activeServiceIds = this.selectedCouriers.reduce((acc, courier) => {
          const selectedServices = courier.services
            .filter(service => service.is_selected)
            .map(service => service.id)
          return [...acc, ...selectedServices]
        }, [])

        await this.syncCourierServices({
          merchantId: this.brandId,
          serviceIds: activeServiceIds,
        })
      } finally {
        this.isSyncing = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
